/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Animal} from '../_models/models';
import {Observable} from 'rxjs';
import {QueryParams, QueryParamsHelper} from '../_helpers/query-params.helper';
import {AbstractService, RESPONSE} from './abstract.service';
import {AnimalImportType} from '../_forms/animal-import-type';

@Injectable()
export class AnimalService extends AbstractService<Animal> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
    super(locale, httpClient, 'animal', 'animals');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                              DELETE                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public deleteBoviclicAnimals(ids: number[], qp?: QueryParams): Observable<HttpResponse<any>> {
    return this.httpClient.delete<any>(`${this.baseUrl}/boviclic-animals`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                GET                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public findBoviclic(qp?: QueryParams): Observable<HttpResponse<Animal[]>> {
    return this.httpClient.get<Animal[]>(`${this.baseUrl}/boviclic-animals`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  public findHistory(thirpartyId: number, dateStart: string, dateEnd: string, qp?: QueryParams): Observable<HttpResponse<Animal[]>> {
    return this.httpClient.get<Animal[]>(`${this.baseUrl}/third-party/${thirpartyId}/history`, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp).set('dateStart', dateStart).set('dateEnd', dateEnd),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                PATCH                                                               ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public checkAnimal(removalPointId: number, animalImport: AnimalImportType, qp?: QueryParams): Observable<HttpResponse<Animal>> {
    return this.httpClient.patch<Animal>(`${this.singleUrl}/check-for-removal-point/${removalPointId}`, JSON.stringify(animalImport), {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

}
